module.exports = __webpack_public_path__ + "static/media/logo_apfel_Vieth_tinypng.ce2e5131.png";